import { DataTypeEnum } from "../../enums/DataTypeEnum";
import { AggregateType, ColumnType, DateRangeType, TimeframeType } from "../../enums/DRCXEnums";
import { NumericalFunctionEnum } from "../../enums/NumericalFunctionEnum";


// different from drcx utility, specifically for LKV, did not want to cause problems elsewhere
// so created a local function
export function makeTatColumnEquatableKey(
    tatID: number,
    dataType: DataTypeEnum,
    groupingTimeframe: TimeframeType,
    groupingFunction?: NumericalFunctionEnum,
    aggregationType?: AggregateType,
    aggregationPeriod?: number,
    aggregationFunction?: number,
    aggregationStepDateRange?: DateRangeType,
    aggregationStep?: number
): string {

    const val = groupingTimeframe === TimeframeType.Hourly ||
        groupingTimeframe === TimeframeType.Daily ||
        groupingTimeframe === TimeframeType.Weekly ||
        groupingTimeframe === TimeframeType.Monthly ||
        groupingTimeframe === TimeframeType.Yearly
        ? `${ColumnType.Tat}:${typeof tatID === "number" ? tatID : ""}:${typeof dataType === "number" ? dataType : ""}:${typeof groupingTimeframe === "number" ? groupingTimeframe : ""}:${typeof groupingFunction === "number" ? groupingFunction : "0"}:${typeof aggregationType === "number" ? aggregationType : "0"}:${typeof aggregationPeriod === "number" ? aggregationPeriod : "0"}:${typeof aggregationFunction === "number" ? aggregationFunction : "0"}:${typeof aggregationStepDateRange === "number" ? aggregationStepDateRange : ""}:${typeof aggregationStep === "number" ? aggregationStep : ""}`

        : groupingTimeframe === TimeframeType.LastKnownValue ?
            groupingFunction !== undefined  ? 
            `${ColumnType.Tat}:${typeof tatID === "number" ? tatID : ""}:${typeof dataType === "number" ? dataType : ""}:${typeof groupingTimeframe === "number" ? groupingTimeframe : ""}:${typeof groupingFunction === "number" ? groupingFunction : "0"}:${typeof aggregationType === "number" ? aggregationType : ""}` :
            `${ColumnType.Tat}:${typeof tatID === "number" ? tatID : ""}:${typeof dataType === "number" ? dataType : ""}:${typeof groupingTimeframe === "number" ? groupingTimeframe : ""}:${typeof aggregationType === "number" ? aggregationType : ""}`
            
        : `${ColumnType.Tat}:${typeof tatID === "number" ? tatID : ""}:${typeof dataType === "number" ? dataType : ""}:${typeof groupingTimeframe === "number" ? groupingTimeframe : ""}`;

        return val;
}
